<template>
  <div class="SignIn">
    <h1>App naam</h1>
    <p>Welkom bij app naam! </p>
    <p>Om poezie te kunnen ontvangen en te delen met vrienden vragen wij jou om eenmalig hier je naam en telefoonnummer
      achter te laten. Wij zullen deze gegevens nooit ergens anders voor gebruiken.</p>

    <form class="SignIn__form" @submit="handleSubmit">
      <label for="input__name">Je voornaam</label>
      <input id="input__name" class="SignIn__input" type="text"/>

      <label for="input__phone">Je telefoonnummer</label>
      <input id="input__phone" class="SignIn__input" type="tel"/>

      <button class="SignIn__input" type="submit">Inloggen / registreren</button>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'SignIn',
    methods: {
      handleSubmit (e) {
        e.preventDefault()
        this.$store.commit('signin', true)
        this.$router.push('/')
      }
    }
  }
</script>

<style>
  .SignIn {
    border-radius: 1em;
    padding: 1em;
    background-color: #fff;

    width: 90%;
    margin: 1em auto;
  }

  .SignIn__form {
    margin-top: 3em;
  }

  .SignIn__input {
    border: 0;
    border-bottom: 2px solid currentColor;
    display: block;
    width: 100%;
    height: 2em;
    font-size: 1em;
    margin-bottom: 1em;
    background-color: transparent;
    text-align: left;
  }

  button.SignIn__input {
    color: #fff;
    background-color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue